import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/atoms/Modal'

const ChecklistItemTagsPreviewModal = ({ title, tagNames = [], children }) => {
  const [open, setOpen] = useState(false)

  if (!Array.isArray(tagNames) || tagNames.length === 0) {
    return null
  }

  return (
    <>
      <TriggerButton
        type='button'
        onClick={e => {
          e.stopPropagation()
          setOpen(true)
        }}
      >
        {children}
      </TriggerButton>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={title || 'Configured tags'}
        minWidthDesktop='520px'
        maxWidthDesktop='620px'
      >
        <Content>
          <Subtitle>
            This is a read-only list of the tags currently configured for this
            file type.
          </Subtitle>
          <Meta>
            {tagNames.length} tag{tagNames.length === 1 ? '' : 's'}
          </Meta>
          <TagList>
            {tagNames.map(tagName => (
              <TagRow key={tagName}>{tagName}</TagRow>
            ))}
          </TagList>
        </Content>
      </Modal>
    </>
  )
}

export default ChecklistItemTagsPreviewModal

const TriggerButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Subtitle = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[700]};
  line-height: 1.5;
`

const Meta = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grey[700]};
`

const TagList = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[500]};
  background: ${({ theme }) => theme.colors.grey[300]};
`

const TagRow = styled.div`
  padding: 12px 14px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.haiti};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[500]};

  &:last-child {
    border-bottom: 0;
  }
`
